import { NgModule } from '@angular/core';
import { SearchFilterPipe } from './search-filter';

@NgModule({
  providers: [SearchFilterPipe],
  declarations: [SearchFilterPipe],
  exports: [SearchFilterPipe],
})
export class SearchFilterPipeModule {}
